/*
**  rui-common-styles-fixed-layout.js
**
**  Styling for fixed layout, for use in LitElement-based apps

*/
import { css } from 'lit';
export const ruiCommonStylesFixedLayout = css `

:host([width="star"]) {
    flex: 1 0 0%;
    min-height: 0;
    min-width: 0; // For <pre> bug
}

:host([width="2-star"]) {
    flex: 2 0 0%;
    min-height: 0;
}

:host([width="3-star"]) {
    flex: 3 0 0%;
    min-height: 0;
}

:host([width="100"]) {
    flex: 0 0 100px;
}

:host([width="150"]) {
    flex: 0 0 150px;
}

:host([width="200"]) {
    flex: 0 0 200px;
}

:host([width="250"]) {
    flex: 0 0 250px;
}

:host([width="300"]) {
    flex: 0 0 300px;
}

:host([width="350"]) {
    flex: 0 0 350px;
}

:host([width="400"]) {
    flex: 0 0 400px;
}

:host([width="450"]) {
    flex: 0 0 450px;
}

:host([width="500"]) {
    flex: 0 0 500px;
}

:host([width="550"]) {
    flex: 0 0 550px;
}

:host([width="600"]) {
    flex: 0 0 600px;
}

:host([width="650"]) {
    flex: 0 0 650px;
}

:host([width="700"]) {
    flex: 0 0 700px;
}

:host([width="750"]) {
    flex: 0 0 750px;
}

:host([width="800"]) {
    flex: 0 0 800px;
}

:host([width="850"]) {
    flex: 0 0 850px;
}

:host([width="900"]) {
    flex: 0 0 900px;
}

:host([width="950"]) {
    flex: 0 0 950px;
}

:host([width="1000"]) {
    flex: 0 0 1000px;
}

:host([width="1050"]) {
    flex: 0 0 1050px;
}

:host([width="1100"]) {
    flex: 0 0 1100px;
}

:host([width="1150"]) {
    flex: 0 0 1150px;
}

:host([width="1200"]) {
    flex: 0 0 1200px;
}

:host([width="1250"]) {
    flex: 0 0 1250px;
}

:host([width="1300"]) {
    flex: 0 0 1300px;
}

:host([width="1350"]) {
    flex: 0 0 1350px;
}

:host([width="1400"]) {
    flex: 0 0 1400px;
}

:host([width="1450"]) {
    flex: 0 0 1450px;
}

:host([width="1500"]) {
    flex: 0 0 1500px;
}

:host([width="1550"]) {
    flex: 0 0 1550px;
}

:host([width="1600"]) {
    flex: 0 0 1600px;
}

:host([width="1650"]) {
    flex: 0 0 1650px;
}

:host([width="1700"]) {
    flex: 0 0 1700px;
}

:host([width="1750"]) {
    flex: 0 0 1750px;
}

:host([width="1800"]) {
    flex: 0 0 1800px;
}

:host([width="1850"]) {
    flex: 0 0 1850px;
}

:host([width="1900"]) {
    flex: 0 0 1900px;
}

:host([width="1950"]) {
    flex: 0 0 1950px;
}

:host([width="2000"]) {
    flex: 0 0 2000px;
}

:host([height="star"]) {
    flex: 1 0 0%;
    min-height: 0;
}

:host([height="2-star"]) {
    flex: 2 0 0%;
    min-height: 0;
}

:host([height="3-star"]) {
    flex: 3 0 0%;
    min-height: 0;
}

:host([height="100"]) {
    height: 100px;
}

:host([height="150"]) {
    height: 150px;
}

:host([height="200"]) {
    height: 200px;
}

:host([height="250"]) {
    height: 250px;
}

:host([height="300"]) {
    height: 300px;
}

:host([height="350"]) {
    height: 350px;
}

:host([height="400"]) {
    height: 400px;
}

:host([height="450"]) {
    height: 450px;
}

:host([height="500"]) {
    height: 500px;
}

:host([height="550"]) {
    height: 550px;
}

:host([height="600"]) {
    height: 600px;
}

:host([height="650"]) {
    height: 650px;
}

:host([height="700"]) {
    height: 700px;
}

:host([height="750"]) {
    height: 750px;
}

:host([height="800"]) {
    height: 800px;
}

:host([height="850"]) {
    height: 850px;
}

:host([height="900"]) {
    height: 900px;
}

:host([height="950"]) {
    height: 950px;
}

:host([height="1000"]) {
    height: 1000px;
}

:host([height="1050"]) {
    height: 1050px;
}

:host([height="1100"]) {
    height: 1100px;
}

:host([height="1150"]) {
    height: 1150px;
}

:host([height="1200"]) {
    height: 1200px;
}

:host([height="1250"]) {
    height: 1250px;
}

:host([height="1300"]) {
    height: 1300px;
}

:host([height="1350"]) {
    height: 1350px;
}

:host([height="1400"]) {
    height: 1400px;
}

:host([height="1450"]) {
    height: 1450px;
}

:host([height="1500"]) {
    height: 1500px;
}

:host([height="1550"]) {
    height: 1550px;
}

:host([height="1600"]) {
    height: 1600px;
}

:host([height="1650"]) {
    height: 1650px;
}

:host([height="1700"]) {
    height: 1700px;
}

:host([height="1750"]) {
    height: 1750px;
}

:host([height="1800"]) {
    height: 1800px;
}

:host([height="1850"]) {
    height: 1850px;
}

:host([height="1900"]) {
    height: 1900px;
}

:host([height="1950"]) {
    height: 1950px;
}

:host([height="2000"]) {
    height: 1000px;
}

`;
